/**
 * 検索キーワードの上限。obbs_api の `IndexRequest::MAX_QUERY_LENGTH`（`max:100`）と対応する。
 *
 * **API は長さを検証してから検索する**ので、超えると 422 になりヒット判定に到達しない。
 * `useSearch` が 422 を握りつぶすため、画面は「0件・該当する商品が見つかりませんでした」に
 * なってしまう（本来ヒットするはずの語でも）。入力欄と検索ページの2段で弾く。
 *
 * `maxlength` は UTF-16 コードユニット数、API の `max:100` は mb 文字数で、
 * コードユニット数は常に mb 文字数以上なので `maxlength="100"` なら API 上限を超えない。
 * ただし URL 直打ち・ブックマーク・外部リンクは入力欄を通らないので、ページ側でも弾く。
 */
export const SEARCH_MAX_KEYWORD_LENGTH = 100;
